export default {
  setNavigation: (state, data) => {
    state.navigation = data
  },
}
